import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'pbc-contact-prompt-horizontal',
  templateUrl: './contact-prompt-horizontal.component.html'
})
export class ContactPromptHorizontalComponent implements OnInit {
  @Input() isVisible : boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
